import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=5709335c&scoped=true&"
import script from "./goodsDetail.vue?vue&type=script&lang=js&"
export * from "./goodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=5709335c&prod&scoped=true&lang=scss&"
import style1 from "./goodsDetail.vue?vue&type=style&index=1&id=5709335c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5709335c",
  null
  
)

export default component.exports